<template>
  <div class="landing-page lapse-effect">
    <section class="hero">
      <h1>Turn Ideas into Real Software — Fast</h1>
      <p>We’re Orbit — your technical launch partner for building, designing, and scaling digital products. Powered by Starlapse.</p>
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Hero Image" class="hero-img" />
      <div class="cta-buttons">
        <a href="https://calendly.com/martendenheijer" target="_blank">Let’s Build Together</a>
      </div>
    </section>

    <section class="expertise">
      <h2>What We Do</h2>
      <div class="cards">
        <div class="card">
          <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Build" class="expertise-img" />
          <div>
            <h3>Build</h3>
            <p>MVPs, enterprise tools, and mobile apps — full-stack development that’s production-ready.</p>
          </div>
        </div>
        <div class="card">
          <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Design" class="expertise-img" />
          <div>
            <h3>Design</h3>
            <p>UX/UI that’s thoughtful and beautiful, led by expert designers who care about usability.</p>
          </div>
        </div>
        <div class="card">
          <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Grow" class="expertise-img" />
          <div>
            <h3>Grow</h3>
            <p>We stay on as your technical partner — iterating, scaling, and expanding your product with you.</p>
          </div>
        </div>
      </div>
    </section>

<section class="why-teams">
  <h2>Why Teams Work with Orbit</h2>
  <div class="why-cards">
    <div class="why-card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Icon 1" class="why-icon" />
      <h3>Full multidisciplinary team</h3>
      <p>Devs, designers, strategists — we bring the full spectrum of talent to your project.</p>
    </div>
    <div class="why-card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Icon 2" class="why-icon" />
      <h3>Fast, no-nonsense MVP development</h3>
      <p>We’re committed to getting your product to market quickly with no fluff.</p>
    </div>
    <div class="why-card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Icon 3" class="why-icon" />
      <h3>No hand-off gaps</h3>
      <p>We design and build everything in one place, ensuring seamless execution.</p>
    </div>
    <div class="why-card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Icon 4" class="why-icon" />
      <h3>Long-term collaboration mindset</h3>
      <p>We’re in it for the long run, helping you grow and scale as your needs evolve.</p>
    </div>
    <div class="why-card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Icon 5" class="why-icon" />
      <h3>Powered by Starlapse’s proven experience</h3>
      <p>Our team's expertise guarantees smooth, reliable product development.</p>
    </div>
  </div>
</section>


    <section class="best-with">
      <h2>We Work Best With:</h2>
      <div class="cards">
        <div class="card">
          <h3>Founders</h3>
          <p>Founders with a software idea</p>
        </div>
        <div class="card">
          <h3>Startups</h3>
          <p>Startups ready to go from concept to MVP</p>
        </div>
        <div class="card">
          <h3>Companies</h3>
          <p>Companies launching internal tools or platforms</p>
        </div>
        <div class="card">
          <h3>Agencies</h3>
          <p>Agencies needing a reliable dev/design partner</p>
        </div>
      </div>
    </section>


<section class="projects">
  <h2>Our Recent Projects</h2>
  <div class="cards">
    <div class="card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Loyalis Project" class="project-img">
      <h3>Loyalis</h3>
      <p>At Loyalis, we supported the digital transformation of their website and streamlined the application process. Our efforts enhanced accessibility, improved user experience, and simplified the workflow for users, ensuring a smoother online interaction.</p>
    </div>
    <div class="card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Boekjaar Project" class="project-img">
      <h3>Boekjaar</h3>
      <p>As a freelance Software Engineer in 2024, I partnered closely with Boekjaar's co-founder to build integrations with external systems. I architected and implemented a scalable data warehouse to structure financial data, enabling the automated generation of annual reports, thus improving platform efficiency.</p>
    </div>
    <div class="card">
      <img src="https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png" alt="Qfact RSX Project" class="project-img">
      <h3>Qfact</h3>
      <p>In collaboration with Qfact, we developed AI-powered features for the RSX Project, drastically reducing administrative workload by 90%. This automation transformed their operational efficiency and delivered significant time savings for the team.</p>
    </div>
  </div>
</section>



    <section class="testimonials">
      <h2>What Our Clients Say</h2>
      <div class="testimonial-cards">
        <div class="testimonial">
          <img src="https://martendenheijer.nl/nl/wp-content/uploads/2024/06/RinckeHelling-scaled.jpg" alt="Testimonial Image" class="testimonial-img" />
          <p>"Starlapse transformed our online presence completely."</p>
          <span>- Rincke Helling, Mendix Developer</span>
        </div>
        <div class="testimonial">
          <img src="https://martendenheijer.nl/nl/wp-content/uploads/2024/06/RinckeHelling-scaled.jpg" alt="Testimonial Image" class="testimonial-img" />
          <p>"Reliable, professional, and always one step ahead."</p>
          <span>- Rincke Helling, Mendix Developer</span>
        </div>
      </div>
    </section>

    <section class="contact">
      <h2>Ready to launch? Let’s talk about your project.</h2>
      <form @submit.prevent>
        <!-- <input type="text" placeholder="Your Name" />
        <input type="email" placeholder="Your Email" />
        <textarea placeholder="Your Message"></textarea> -->
        <a href="https://calendly.com/martendenheijer" target="_blank">Get in Touch</a>
      </form>
    </section>

    <footer class="footer">
      <div class="footer-links">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Service</a>
        <a href="#">Sitemap</a>
      </div>
      <p>&copy; 2025 Starlapse. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
@keyframes lapseEffect {
  0% {
    box-shadow: 0 2px 10px rgba(255, 183, 77, 0.05);
    border-color: rgba(255, 183, 77, 0.1);
  }
  25% {
    box-shadow: 0 2px 10px rgba(255, 235, 121, 0.06);
    border-color: rgba(255, 235, 121, 0.12);
  }
  50% {
    box-shadow: 0 2px 10px rgba(129, 212, 250, 0.05);
    border-color: rgba(129, 212, 250, 0.1);
  }
  75% {
    box-shadow: 0 2px 10px rgba(57, 128, 202, 0.05);
    border-color: rgba(57, 128, 202, 0.1);
  }
  100% {
    box-shadow: 0 2px 10px rgba(255, 183, 77, 0.05);
    border-color: rgba(255, 183, 77, 0.1);
  }
}

.landing-page {
  font-family: 'Helvetica Neue', sans-serif;
  background: #f9f9f9;
  color: #111;
  display: flex;
  flex-direction: column;
  gap: 6rem;
}

section {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.hero {
  text-align: center;
  padding: 6rem 2rem 4rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.hero-img {
  border-radius: 1rem;
  max-width: 100%;
  margin-bottom: 2rem;
  box-shadow: 0

2px 10px rgba(255, 183, 77, 0.05);
}

.cta-buttons {
display: flex;
justify-content: center;
}

.cta-buttons button, .cta-buttons a {
padding: 1.2rem 3rem;
background-color: #3f5d71;
color: white;
border: none;
font-size: 1rem;
border-radius: 50px;
cursor: pointer;
box-shadow: 0 2px 10px rgba(57, 128, 202, 0.15);
transition: background-color 0.3s;
text-decoration: none;
}

.cta-buttons button:hover, .cta-buttons a:hover {
background-color: #2c3e50;
}

.expertise {
text-align: center;
padding: 3rem 2rem;
}

.expertise h2 {
font-size: 2.5rem;
margin-bottom: 3rem;
}

.cards {
display: grid;
grid-template-columns: 1fr 1fr 1fr;
gap: 2rem;
}

.card {
display: flex;
flex-direction: column;
align-items: center;
gap: 1rem;
}

.expertise-img {
width: 80%;
max-width: 200px;
}
.why-teams {
  text-align: center;
  background-image: url('https://martendenheijer.my.canva.site/starlapse/images/8b3559a0ba5372ebf60e223d0b8a9346.png');
  background-size: cover;
  background-position: center;
  padding: 6rem 2rem;
  position: relative;
}

.why-teams::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.why-teams h2 {
  color: white;
  font-size: 2.5rem;
  z-index: 1;
}

.why-cards {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  z-index: 1;
}

.why-card {
  background: rgba(255, 255, 255, 0.85);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  width: 250px;
  text-align: center;
}

.why-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
}

.why-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 1rem;
}

.why-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.why-card p {
  font-size: 1rem;
  color: #333;
}

.best-with {
  text-align: center;
  padding: 3rem 2rem;
}

.best-with h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
}

.best-with .cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
}

.best-with .card {
  background-color: #fff;
  padding: 2rem;
  width: calc(50% - 1rem);
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(255, 183, 77, 0.05);
  border-radius: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.best-with .card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.best-with .card p {
  font-size: 1rem;
}

.best-with .card:hover {
  transform: translateY(-5px);
  box-shadow: 0 2px 20px rgba(57, 128, 202, 0.2);
}

@media (max-width: 768px) {
  .best-with .card {
    width: 100%;
  }
}

.projects {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers the content horizontally */
  text-align: center; /* Centers the text inside each card */
}

.cards {
  display: flex;
  justify-content: center; /* Centers the cards horizontally */

  gap: 20px; /* Adjust the spacing between the cards */
  flex-wrap: wrap; /* Allows the cards to wrap on smaller screens */
}

.card {
  width: 300px; /* Set a fixed width for the cards */
  margin: 10px;
}

.project-img {
  width: 100%;
  height: auto;
}

.projects h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.projects h3 {
  font-size: 1.5rem;
  margin-top: 10px;
}

.projects p {
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 10px;
}


.project-img {
width: 100%;
border-radius: 1rem;
}

.testimonials {
background-color: #f3f3f3;
padding: 3rem 2rem;
}

.testimonials h2 {
font-size: 2.5rem;
margin-bottom: 3rem;
}

.testimonial-cards {
display: flex;
gap: 2rem;
justify-content: center;
}

.testimonial {
max-width: 400px;
text-align: center;
}

.testimonial-img {
border-radius: 50%;
width: 100px;
height: 100px;
object-fit: cover;
margin-bottom: 1rem;
}

.contact {
text-align: center;
padding: 3rem 2rem;
}

.contact h2 {
font-size: 2.5rem;
margin-bottom: 3rem;
}

.contact form {
display: flex;
flex-direction: column;
gap: 1.5rem;
max-width: 500px;
margin: 0 auto;
}

.contact input,
.contact textarea {
padding: 1rem;
border-radius: 8px;
border: 1px solid #ddd;
}

.contact button, .contact a {
padding: 1.2rem 3rem;
background-color: #3f5d71;
color: white;
border: none;
font-size: 1rem;
border-radius: 50px;
cursor: pointer;
transition: background-color 0.3s;
text-decoration: none;
}

.contact button:hover, .contact a:hover {
background-color: #2c3e50;
}

.footer {
background-color: #111;
color: white;
padding: 2rem 2rem;
text-align: center;
}

.footer a {
color: #fff;
margin: 0 1rem;
text-decoration: none;
}

.footer p {
margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue